import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white/50">Laden...</div>;
  }
  if (user === false) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};
